<template lang="html">
    <div id="loadChargeApp" class="loaderPoints" v-if="active">
        <div class="h-100 w-100 position-relative d-flex justify-content-center align-items-center align-content-center">
            <img :src="logo" class="mbLogo">
            <img :src="a13" class="spinner">
        </div>
    </div>
</template>
<script>
export default {
    name:"loaderAnim",
    props:{
        active:{
            default: false,
            type: Boolean
        }
    },
    data(){
        return{
            a13:require('@/assets/images/a13.png'),
            logo:require('@/assets/images/franchise/logo.jpg'),
        }
    }
}
</script>
<style lang="css" scoped>
#loadChargeApp.loaderPoints{
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: all;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    z-index: 9999;
    animation: fade 1s forwards;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.7);
}

#loadChargeApp.loaderPoints .mbLogo{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    object-fit: cover;
    position: absolute;
    margin: auto;
    animation: palp 1s linear infinite;
    pointer-events: none;
}
#loadChargeApp.loaderPoints .spinner{
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    animation: charge 1s linear infinite;
    pointer-events: none;
}

@keyframes charge{
    0%{
        transform: rotate(0);
    }
    50%{
        transform:  rotate(180deg) scale(0.8);
    }
    100%{
        transform: rotate(360deg);
    }
}
@keyframes fade{
    0%{
        opacity: 0;
    }
    50%{
        opacity: 0.8;
    }
}
@keyframes palp{
    50%{
        transform: scale(0.8);
        opacity: 0.5;
    }
}
</style>
